
import Cell from 'vux/src/components/cell/index.vue'

import { InsurStore } from "../../store";
import Moment from "moment";
import { EndTimeCountDownMixins } from "../_utils";

export default {
mixins: [EndTimeCountDownMixins],
props: {
commodityPrice: {
type: String,
},
markingPrice: {
type: String,
},
isMultiplePrice: {
type: Boolean,
default: false,
},
},
data() {
return {
banner: "",
stateInfo: "",
};
},
components: {
Cell,
},
computed: {
insurance() {
return InsurStore.insurance;
},
state() {
if (JSON.stringify(this.insurance) == "{}") {
return false;
}


if (this.insurance.isActive === 0) {
this.stateInfo = "已下架";
this.statusClass = "status-disabled";
return 3;
}

if (this.insurance.beginTime && this.diff(this.insurance.beginTime) < 0) {
this.stateInfo =
Moment(this.insurance.beginTime).format("MM-DD HH:mm:ss") + " 开始";
this.statusClass = "status-highlight";
return 3;
}

if (this.insurance.endTime && this.diff(this.insurance.endTime) > 0) {
this.stateInfo = "活动已结束";
this.statusClass = "status-disabled";
return 3;
}

if (this.insurance.stock != null && this.insurance.stock - 1 < 0) {
this.stateInfo = "暂无库存";
this.statusClass = "status-disabled";
return 3;
}

const remindCount =
this.insurance.remindCount != null
? Number(this.insurance.remindCount)
: undefined;
if (
remindCount &&
this.insurance.stock &&
this.insurance.stock <= remindCount
) {
this.stateInfo = "仅剩" + this.insurance.stock + "份";
this.statusClass = "status-highlight";
return 2;
}

const remindTime = this.insurance.remindTime;
if (
remindTime != null &&
this.insurance.endTime &&
this.diff(this.insurance.endTime) < 0 &&
this.diff(remindTime) >= 0
) {
this.stateInfo = "倒计时：";
this.countDownTargetTime = this.insurance.endTime;
this.startCountDown();
return 1;
}
return true;
},
},
created() {
this.banner = this.insurance.bannerUrl;
},
methods: {

diff(t) {
const time = Moment(t).format("YYYY-MM-DD HH:mm:ss");

const mydate = Moment();
return mydate.diff(time);
},
},
};
